export const SetRoutineStateActionType = 'SET_ROUTINE_STATE';
export const setRoutineState = newState => ({
  type: SetRoutineStateActionType,
  routineState: newState
});
